<template>
  <div class="kv-ve__group">
    <div class="form-group">
      <label>{{ $_("visualEditor-emailEditor-common-heightPx") }}</label>
      <input class="form-control" type="number" v-model.number="block.settings.height" min="0" />
    </div>

    <VeBlockMarginsSettings :block="block" />

  </div>
</template>

<script>
import VeBlockMarginsSettings from "../VeBlockMarginsSettings.vue";

export default {
  name: "VeSpacerBlockSettings",
  components: { VeBlockMarginsSettings },
  props: {
    block: { type: Object, required: true },
    paletteLabel: { type: String, required: true },
  },
};
</script>


